import { Box, Typography, useTheme } from '@mui/material';

const ComparisonSingleTeam = ({ parameter, teamValue, borderColor }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '19.5%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                p: 1,
                border: '1px solid',
                borderColor: theme.palette.border?.main || 'border.main',
                borderTop: '3px solid',
                borderTopColor: borderColor || theme.palette.border?.main || 'border.main',
                borderRadius: 1,
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontSize: '22px',
                    fontWeight: 600,
                    color: 'text.primary',
                    lineHeight: 1.2,
                }}
            >
                {teamValue}
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    fontSize: '12px',
                    color: 'text.secondary',
                    fontWeight: 400,
                    mb: 0.5,
                    letterSpacing: '0.5px',
                }}
            >
                {parameter}
            </Typography>
        </Box>
    );
};

export default ComparisonSingleTeam;
